module.exports = new Promise((resolve,reject) => {
                  const remoteUrl = window.__CONFIG__.REACT_APP_PARTNER_PROGRAM_REMOTE_URL;
                  const script = document.createElement('script');
                  script.src = remoteUrl;
                  script.onload = () => {
                  const proxy = {
                      get: (request) => window.partner.get(request),
                      init: (arg) => {
                      try {
                        return window.partner.init(arg);
                      } catch (e) {
                        console.warn('partner remote already initialized');
                      }
                    }
                  };
                  resolve(proxy);
                };
                script.onerror = (err) =>{
                  console.log('Failed to load remote script',err);
                  reject(new Error('Unable to load RemoteEntry file for partner MFE'));
                }
                document.head.appendChild(script);
          });